'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

const links = [
  { href: '/chat', label: 'AI相談' },
  { href: '/library', label: '動画ライブラリ' },
  { href: '/admin', label: '管理' },
];

export default function Nav() {
  const pathname = usePathname();

  return (
    <nav
      style={{ backgroundColor: 'var(--color-bg)', borderBottom: '1px solid var(--color-border)' }}
      className="fixed top-0 left-0 right-0 z-50"
    >
      <div className="max-w-5xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link
          href="/"
          style={{ color: 'var(--color-text)', letterSpacing: '0.2em' }}
          className="text-sm font-light"
        >
          ハンドメイド知識庫
        </Link>

        <ul className="flex items-center gap-8">
          {links.map(({ href, label }) => (
            <li key={href}>
              <Link
                href={href}
                style={{
                  color: pathname === href ? 'var(--color-accent)' : 'var(--color-muted)',
                  letterSpacing: '0.1em',
                  borderBottom: pathname === href ? '1px solid var(--color-accent)' : 'none',
                  paddingBottom: '2px',
                }}
                className="text-sm transition-colors duration-300 hover:opacity-80"
              >
                {label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}
